import React from "react"
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { H2 } from "../../../designSystem/typography/Heading";
import { getInspectionPointUsage } from "../../../api/safetyInspectionClientApi";
import { InspectionPointUsage } from "../../../amorg-common";
import { OnOff } from "../../../designSystem/inputs/OnOff";
import { InstructionText } from "../../../features/safetyInspection/inspectionPoint/InstructionText";


export const InspectionPointOverview = (): JSX.Element => 
{
    const [defaultCollapsed, setDefaultCollapsed] = React.useState(true);
    const [inspectionPoints, setInspectionPoints] = React.useState<InspectionPointUsage[]>([]);
    
    React.useEffect(()=>{
        (async () => {
            const data = await getInspectionPointUsage();
            setInspectionPoints(data.sort((a,b) => a.inspectionPointId.localeCompare(b.inspectionPointId)));
        })();
    }, []);

    return (
        <>
            <Flex>
                Default collapsed
                <OnOff active={defaultCollapsed} onClick={(value) => setDefaultCollapsed(value)} />
            </Flex>
            {inspectionPoints.map(ip =>
                <Flex key={ip.inspectionPointId} flexDirection="column" gap={4}>
                    <div>
                        <H2>{ip.inspectionPointId}</H2>
                        <b>{ip.title}</b><br />
                        <InstructionText text={ip.instructions} defaultCollapsed={defaultCollapsed}  />
                    </div>
                </Flex>
            )}
        </>
    );
}

